// import { createContext, useContext, useEffect, useMemo, useState } from "react";
// import { useTranslation } from "react-i18next";
// import { Emission_Detail_Options } from "../../db_access/emission_detail_options";
// import { Env_Factor_Options } from "../../db_access/env_factor_options";

// const Context = createContext(null);

// export const ContextProvider = ({ children }) => {
//   const { i18n } = useTranslation();
//   const [selectedLanguage, setSelectedLanguage] = useState("en");
//   const [selectedProducts, setSelectedProducts] = useState([]);
//   const [selectedProjects, setSelectedProjects] = useState([]);
//   const [selectedBuildings, setSelectedBuildings] = useState([]);
//   const [leftSidebarCollapse, setLeftSidebarCollapse] = useState(false);
//   const [rightSidebarCollapse, setRightSidebarCollapse] = useState(false);
//   const [refresh, setRefresh] = useState(true);
//   const [columnVisibilities, setColumnVisibilities] = useState({});
//   const [isLoading, setIsLoading] = useState(false);
//   const [isSaveClicked, setIsSaveClicked] = useState(false);
//   const [isSaveVisible, setIsSaveVisible] = useState(false);
//   const [selectedProductIds, setSelectedProductIds] = useState([]);
//   const [selectedProjectIds, setSelectedProjectIds] = useState([]);
//   const [selectedBuildingIds, setSelectedBuildingIds] = useState([]);
//   const [envFactorOptions, setEnvFactorOptions] = useState({});
//   const [emissionDetailOptions, setEmissionDetailOptions] = useState({});
//   const [selectedSupplyChains, setSelectedSupplyChains] = useState([]);
//   const [selectedStructures, setSelectedStructures] = useState([]);
//   const [selectedCorporates, setSelectedCorporates] = useState([]);

//   const selectedSupplyChain = useMemo(() => (selectedSupplyChains.length === 1 ? selectedSupplyChains[0] : null), [selectedSupplyChains]);
//   const selectedSupplyChainId = useMemo(() => (selectedSupplyChain ? selectedSupplyChain.id : null), [selectedSupplyChain]);

//   const selectedStructure = useMemo(() => (selectedStructures.length === 1 ? selectedStructures[0] : null), [selectedStructures]);
//   const selectedStructureId = useMemo(() => (selectedStructure ? selectedStructure.id : null), [selectedStructure]);

//   const selectedCorporate = useMemo(() => (selectedCorporates.length === 1 ? selectedCorporates[0] : null), [selectedCorporates]);
//   const selectedCorporateId = useMemo(() => (selectedCorporate ? selectedCorporate.id : null), [selectedCorporate]);

//   const supplyChainContext = useMemo(
//     () => ({ selectedSupplyChains, setSelectedSupplyChains, selectedSupplyChain, selectedSupplyChainId }),
//     [selectedSupplyChains, selectedSupplyChain, selectedSupplyChainId]
//   );
//   const structureContext = useMemo(
//     () => ({ selectedStructures, setSelectedStructures, selectedStructure, selectedStructureId }),
//     [selectedStructures, selectedStructure, selectedStructureId]
//   );
//   const corporateContext = useMemo(
//     () => ({ selectedCorporates, setSelectedCorporates, selectedCorporate, selectedCorporateId }),
//     [selectedCorporates, selectedCorporate, selectedCorporateId]
//   );
//   const organizationContext = useMemo(() => ({ ...supplyChainContext, ...structureContext, ...corporateContext }), [supplyChainContext, structureContext, corporateContext]);

//   const productContext = useMemo(
//     () => ({ selectedProducts, setSelectedProducts, selectedProductIds, setSelectedProductIds }),
//     [selectedProducts, setSelectedProducts, selectedProductIds, setSelectedProductIds]
//   );
//   const projectContext = useMemo(
//     () => ({ selectedProjects, setSelectedProjects, selectedProjectIds, setSelectedProjectIds }),
//     [selectedProjects, setSelectedProjects, selectedProjectIds, setSelectedProjectIds]
//   );
//   const buildingContext = useMemo(
//     () => ({ selectedBuildings, setSelectedBuildings, selectedBuildingIds, setSelectedBuildingIds }),
//     [selectedBuildings, setSelectedBuildings, selectedBuildingIds, setSelectedBuildingIds]
//   );

//   const sectorContext = useMemo(() => ({ ...productContext, ...projectContext, ...buildingContext }), [productContext, projectContext, buildingContext]);
//   const context = useMemo(
//     () => ({
//       selectedLanguage,
//       setSelectedLanguage,
//       leftSidebarCollapse,
//       setLeftSidebarCollapse,
//       rightSidebarCollapse,
//       setRightSidebarCollapse,
//       refresh,
//       setRefresh,
//       columnVisibilities,
//       setColumnVisibilities,
//       isLoading,
//       setIsLoading,
//       isSaveClicked,
//       setIsSaveClicked,
//       isSaveVisible,
//       setIsSaveVisible,
//       envFactorOptions,
//       emissionDetailOptions,
//       ...sectorContext,
//       ...organizationContext,
//     }),
//     [
//       selectedLanguage,
//       leftSidebarCollapse,
//       rightSidebarCollapse,
//       refresh,
//       columnVisibilities,
//       isLoading,
//       isSaveClicked,
//       isSaveVisible,
//       envFactorOptions,
//       emissionDetailOptions,
//       sectorContext,
//       organizationContext,
//     ]
//   );

//   useEffect(() => {
//     i18n.changeLanguage(selectedLanguage);
//   }, [selectedLanguage, i18n]);
//   useEffect(() => {
//     // Load emission options
//     Emission_Detail_Options.getAll()
//       .then((res) => res.json())
//       .then((data) => {
//         if (!data) return;
//         const types = Array.from(new Set(data.map((option) => option.type))).sort();
//         const options = {};
//         types.forEach((type) => {
//           options[type] = {};
//         });
//         data.forEach(({ type, category, sub_category, description, ...e }) => {
//           if (!options[type][category]) {
//             options[type][category] = {};
//           }
//           if (!options[type][category][sub_category]) {
//             options[type][category][sub_category] = {};
//           }
//           if (!options[type][category][sub_category][description]) {
//             options[type][category][sub_category][description] = [];
//           }
//           options[type][category][sub_category][description].push({ type, category, sub_category, description, ...e });
//         });
//         setEmissionDetailOptions(options);
//       });

//     //  load env factor options
//     Env_Factor_Options.getAll()
//       .then((res) => res.json())
//       .then((data) => {
//         if (!data) return;
//         const options = {};
//         data.forEach(({ type, category, sub_category, description, ...e }) => {
//           if (!options[type]) {
//             options[type] = {};
//           }
//           if (!options[type][category]) {
//             options[type][category] = {};
//           }
//           if (!options[type][category][sub_category]) {
//             options[type][category][sub_category] = {};
//           }
//           if (!options[type][category][sub_category][description]) {
//             options[type][category][sub_category][description] = [];
//           }
//           options[type][category][sub_category][description].push({ type, category, sub_category, description, ...e });
//         });
//         setEnvFactorOptions(options);

//         // console.log(
//         //   "Fetched Env Factor data",
//         //   data.map((d, idx) => ({ type: d.type, category: d.category, sub_category: d.sub_category, description: d.description, id: idx }))
//         // );
//       });
//   }, []);
//   return <Context.Provider value={context}>{children}</Context.Provider>;
// };

// export const useContextProvider = () => {
//   const ctx = useContext(Context);
//   if (!ctx) throw new Error("useContextProvider must be used within ContextProvider");
//   return ctx;
// };

import { createContext, useContext, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

import Loading from "../dialog/Loading";
import SnackbarAlert from "../notification/SnackbarAlert";
import { useOptionsSlice } from "./Slices/useOptionsSlice";
import { useOrganizationSlice } from "./Slices/useOrganizationSlice";
import { useSectorSlice } from "./Slices/useSectorSlice";
import { useUISlice } from "./Slices/useUISlice";

const Context = createContext(null);

export const ContextProvider = ({ children }) => {
  const { i18n } = useTranslation();

  const ui = useUISlice();
  const sectorContext = useSectorSlice();
  const organizationContext = useOrganizationSlice();
  const options = useOptionsSlice();

  useEffect(() => {
    i18n.changeLanguage(ui.selectedLanguage);
  }, [ui.selectedLanguage, i18n]);

  const context = useMemo(() => ({ ...ui, ...options, ...sectorContext, ...organizationContext }), [ui, options, sectorContext, organizationContext]);

  return (
    <Context.Provider value={context}>
      {children}
      <Loading />
      <SnackbarAlert />
    </Context.Provider>
  );
};

export const useContextProvider = () => {
  const ctx = useContext(Context);
  if (!ctx) throw new Error("useContextProvider must be used within ContextProvider");
  return ctx;
};
